import { Injectable } from '@angular/core';
import {PrimeNGConfig} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class PrimengLocalizationService {

  constructor(private config: PrimeNGConfig) {

  }

  setLanguage(language: 'et' | 'en'){
    if(language == 'et'){
      this.config.setTranslation({
        "startsWith": "Algab",
        "contains": "Sisaldab",
        "notContains": "Ei sisalda",
        "endsWith": "Lõpeb",
        "equals": "Võrdub",
        "notEquals": "Ei võrdu",
        "noFilter": "Filtrita",
        "lt": "Vähem kui",
        "lte": "Vähem või võrdne",
        "gt": "Rohkem kui",
        "gte": "Rohkem või võrdne",
        "is": "On",
        "isNot": "Ei ole",
        "before": "Enne",
        "after": "Peale",
        "dateIs": "Kuupäev on",
        "dateIsNot": "Kuupäev ei ole",
        "dateBefore": "Kuupäev on enne",
        "dateAfter": "Kuupäev on pärast",
        "clear": "Puhasta",
        "apply": "Rakenda",
        "matchAll": "Sobita kõik",
        "matchAny": "Sobita mõni",
        "addRule": "Lisa reegel",
        "removeRule": "Eemdalda reegel",
        "accept": "Jah",
        "reject": "Ei",
        "choose": "Vali",
        "upload": "Lae üles",
        "cancel": "Tühista",
        "dayNames": ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"],
        "dayNamesShort": ["P", "E", "T", "K", "N", "R", "L"],
        "dayNamesMin": ["P", "E", "T", "K", "N", "R", "L"],
        "monthNames": ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"],
        "monthNamesShort": ["jaan", "veebr", "märts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
        "dateFormat": "mm.dd.yy",
        "firstDayOfWeek": 0,
        "today": "Täna",
        "weekHeader": "Näd",
        "weak": 'Nõrk',
        "medium": 'Keskmine',
        "strong": 'Tugev',
        "passwordPrompt": 'Sisesta parool',
        "emptyMessage": 'Tulemused puuduvad',
        "emptyFilterMessage": 'Tulemused puuduvad'
      });
      this.config.translation['exists'] = 'Eksisteerib';
      this.config.translation['between'] = 'Vahemikus';
    }
    if(language == 'en'){
      this.config.setTranslation({
        "startsWith": "Starts with",
        "contains": "Contains",
        "notContains": "Not contains",
        "endsWith": "Ends with",
        "equals": "Equals",
        "notEquals": "Not equals",
        "noFilter": "No Filter",
        "lt": "Less than",
        "lte": "Less than or equal to",
        "gt": "Greater than",
        "gte": "Greater than or equal to",
        "is": "Is",
        "isNot": "Is not",
        "before": "Before",
        "after": "After",
        "dateIs": "Date is",
        "dateIsNot": "Date is not",
        "dateBefore": "Date is before",
        "dateAfter": "Date is after",
        "clear": "Clear",
        "apply": "Apply",
        "matchAll": "Match All",
        "matchAny": "Match Any",
        "addRule": "Add Rule",
        "removeRule": "Remove Rule",
        "accept": "Yes",
        "reject": "No",
        "choose": "Choose",
        "upload": "Upload",
        "cancel": "Cancel",
        "dayNames": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        "dayNamesMin": ["Su","Mo","Tu","We","Th","Fr","Sa"],
        "monthNames": ["January","February","March","April","May","June","July","August","September","October","November","December"],
        "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        "dateFormat": "mm/dd/yy",
        "firstDayOfWeek": 0,
        "today": "Today",
        "weekHeader": "Wk",
        "weak": "Weak",
        "medium": "Medium",
        "strong": "Strong",
        "passwordPrompt": "Enter a password",
        "emptyMessage": "No results found",
        "emptyFilterMessage": "No results found"
      });

      this.config.translation['exists'] = 'Exists';
      this.config.translation['between'] = 'Between';
    }
  }
}
